enum AbaTypeGroupEnum {
    PrefundPrepaidInterest = 'PREFUND_PREPAID_INTEREST',
    RepaymentPrincipal = 'REPAYMENT_PRINCIPAL',
    SalePrincipal = 'SALE_PRINCIPAL',
    SellInPrepaidInterest = 'SELL_IN_PREPAID_INTEREST',
}

export default AbaTypeGroupEnum;